export const getCorsOriginHeader = (url: string): string | null => {
    const allowedPatterns = [
        /^https:\/\/.*gfk.*\.com(:\d+)?$/
    ];

    try {
        const urlOrigin = new URL(url).origin;
        const matchedPattern = allowedPatterns.find(pattern => pattern.test(urlOrigin));

        if (!matchedPattern) {
            throw new Error(`Domain not allowed: ${urlOrigin}`);
        }

        return urlOrigin;
    } catch {
        throw new Error(`Invalid URL or Domain not allowed: ${url}`);
    }
};
